/**
 * Sidebar menu constants
 * Centralized constants for menu IDs, dimensions, and transitions
 */

export const MENU_IDS = {
  MAIN: "mainMenu",
  SETTINGS: "settingsSubmenu",
} as const;

export type MenuId = (typeof MENU_IDS)[keyof typeof MENU_IDS];

export const DRAWER_WIDTHS = {
  NARROW: 52,
  EXPANDED: 310,
} as const;

export const TRANSITION_DURATION = 250;
